import { Brand, createBranded } from '@deltasierra/type-utilities';

export type LocationTemplateCustomMergeFieldId = Brand<number, 'LocationTemplateCustomMergeFieldId'>;
export const LocationTemplateCustomMergeFieldId = createBranded<LocationTemplateCustomMergeFieldId>();
